export default {
  path: '/lvy-let-sign',
  component: () => import('./LVYLetSign'),
  meta: {
    title: '电子牵服务协议与数字证书申请协议',
    designWidth: 750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}